import {HttpClient} from "@angular/common/http";
import {TranslateLoader} from "@ngx-translate/core";
import {Observable, of} from "rxjs";
import { WindowRefService } from "../window-ref.service";
//import merge from 'deepmerge';


export interface ITranslationResource {
    prefix: string;
    suffix: string;
}

export class TranslateHttpLoader implements TranslateLoader {

    constructor(private http: HttpClient,private winRef:WindowRefService ) {
    }

    public getTranslation(lang: string): Observable<any> {
        return this.winRef.getTranslation(lang);
    }

    

}